import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';

var pledge = {};

(function (pledgeApp) {

    var requestModel = {
        Pledges: []
    };

    pledgeApp.GetPopup = function () {
        $.ajax({
            contentType: 'application/json; charset=utf-8',
            url: "/umbraco/surface/PledgeSurface/GetPopup",
            type: "POST",
            data: JSON.stringify(requestModel),
            dataType: "html",
            success: function (data) {
                $(".js-pledge-popup-form-container").html(data);
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    pledgeApp.Submit = function () {
        $.ajax({
            url: "/umbraco/surface/PledgeSurface/Submit",
            type: "POST",
            data: $('.js-pledge-form').serialize(),
            dataType: "html",
            success: function (data) {
                $(".js-pledge-form-container").html(data);
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {

        $(document).on('click', '.js-complete-pledge-button', function (e) {
            e.preventDefault();

            var selectedPledges = [];

            $('.js-pledge-checboxes input:checked').each(function () {
                let pledge = {};
                pledge.UbiquityValue = $(this).attr('id');
                pledge.Name = $(this).attr('name');
                selectedPledges.push(pledge);
            });

            requestModel.Pledges = selectedPledges;

            pledge.GetPopup();

            $.fancybox.open({
                src: '#pledge-popup',
                type: 'inline'
            });
        });

        $(document).on('click', '.js-pledge-popup-close', function (e) {
            e.preventDefault();

            $.fancybox.close();
        });

        $(document).on('submit', '.js-pledge-form', function (e) {
            e.preventDefault();
            pledge.Submit();
        });

    });

})(pledge);
